/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { Pipe, PipeTransform } from '@angular/core';
import { ModelProperty } from '../engine/model-property';

@Pipe({
  name: 'title',
  standalone: true,
})
/**
 * @Deprecated : old title pipe, use modelPropertyTitle pipe instead
 * argument "title" not even used inside the pipe
 */
export class TitlePipe implements PipeTransform {
  transform(
    title: string,
    context: 'table' | 'form' | 'details' | 'search',
    property: ModelProperty,
  ): string {
    let titleByContext = '';
    switch (context) {
      case 'table':
        titleByContext = property.titleByContext.table;
        break;
      case 'form':
        titleByContext = property.titleByContext.form;
        break;
      case 'details':
        titleByContext = property.titleByContext.details;
        break;
      case 'search':
        titleByContext = property.titleByContext.search;
        break;
    }
    return titleByContext ? titleByContext : property.title;
  }
}
